import { Document } from '@quadminds/client-apis/agents';
import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to upload a file using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the upload.
 */
export const useUpdateDocument = () => {
    return useMutation({
        mutationFn: ({
            documentId,
            organizationId,
            payload,
        }: {
            documentId: string;
            organizationId: string;
            payload: Partial<Document>;
        }) => {
            // Simple conversion by excluding problematic fields and adding only compatible ones
            const apiPayload: Record<string, unknown> = {};

            // Only include fields that exist in both types and are compatible
            if (payload.active !== undefined) apiPayload['active'] = payload.active;
            if (payload.organization_id !== undefined) apiPayload['organization_id'] = payload.organization_id;
            if (payload.parent_id !== undefined) {
                apiPayload['parent_id'] = payload.parent_id ?? payload.parent_id;
            }

            apiPayload['name'] = payload.name;
            apiPayload['active'] = payload.active;

            return chatService.updateKnowledgeDocument(documentId, organizationId, apiPayload);
        },
    });
};
